import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TemplateModel } from './../models/template.model';
import { DataListModel, ApplicationRouteURL, WeGoAuthorizedLink, Permission, PermissionType } from './../../shared/config';
import { TemplateService } from './../models/template.service';
import { RoleLevel } from "../../shared/config";

@Component({
  selector: 'wego-template-list',
  template: require('../views/template-list.component.html'),
  providers: [TemplateService],
})
export class TemplateListComponent implements OnInit {
  DataListModel: DataListModel;
  templateList: TemplateModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  urlTemplateUpdatePage: string;
  isParentCheck: boolean;
  deleteVehicleMasterHashId: string;
  errorMessage: string;
  isMultipleDelete: boolean;
  deleteMessage: string;
  addTemplateLink : any;
  urlTemplateADDPage : string;
  roleLevel = RoleLevel;

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('childModal') public childModal: any;
  private popupMsg: string;
  private module: string;

  get isAnyChecked(): boolean {
    if (this.templateList) {
      let isCheck = this.templateList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.templateList.every(x => x.isChecked == true || (x.customerHashId ? true : false) == false))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isAnyDeletable(): boolean {
    if (this.templateList) {
      return this.templateList.some(x => (x.customerHashId ? true : false) == true);
    }
    return false;
  }

  get isDeleteAccess(): boolean {
    if (this.templateList) {
      return this.templateList.some(x => x.isDeletable);
    }
    else { return false; }
  }


  constructor(private templateService: TemplateService,
    private translateService: TranslateService,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.module = this.translateService.instant('LblTemplate');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);

    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Customer) {
      this.DataListModel.searchField = ["templateName", "subjectHTml", "instanceName", "customerName", "companyName", "sharedVehicleGroupName", "organizationName"];
    }
    else if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance)
    {
      this.DataListModel.searchField = ["templateName", "subjectHTml", "instanceName", "companyName", "sharedVehicleGroupName", "organizationName"];
    }
    else if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)
    {
      this.DataListModel.searchField = ["templateName", "subjectHTml", "companyName", "sharedVehicleGroupName", "organizationName"];
    }
    else if(this.authService.GetHighestRoleLevel() <= this.roleLevel.Organization)
    {
      this.DataListModel.searchField = ["templateName", "subjectHTml", "organizationName"];
    }
    else
    {
      this.DataListModel.searchField = ["templateName", "subjectHTml", "sharedVehicleGroupName", "organizationName"];
    }
    
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlTemplateUpdatePage = this.authService.GetURL(ApplicationRouteURL.URL_TEMPLATE_UPDATE);
    this.urlTemplateADDPage = this.authService.GetURL(ApplicationRouteURL.URL_TEMPLATE_ADD);
    this.GetTemplateList();

    this.addTemplateLink = new WeGoAuthorizedLink(this.urlTemplateADDPage, 
      Permission.PR_TEMPLATES, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public GetTemplateList() {
    this.isLoading = true;

    this.templateService.GetTemplateList(this.DataListModel)
      .subscribe(
      res => {
        this.templateList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
        this.templateList = [];
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetTemplateList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetTemplateList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetTemplateList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetTemplateList();
  };

  public OnExport(event: any) {
    // this.isLoading = true;
    // this.templateService.ExportInstanceList(this.DataListModel)
    //   .subscribe(
    //   res => {
    //     if (res && res._body) {
    //       let fileName = "Template" + new Date().toISOString() + ".csv";
    //       this.authService.DownloadFile(fileName, res._body);
    //     }
    //     this.isLoading = false;
    //   },
    //   error => {
    //     this.HandleErrorStatusCode(error);
    //     this.isLoading = false;
    //   });
  }

  public OnParentCheck(isChecked: boolean) {
    this.templateList.filter(x => x.isDeletable).forEach(x => x.isChecked = (isChecked && x.instanceHashId ? true : false));
  }

  public ShowChildModal(templateHashId?: string): void {
    if (templateHashId) {
      this.popupMsg = this.translateService.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteVehicleMasterHashId = templateHashId;
    }
    else {
      this.popupMsg = this.translateService.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.childModal.show();
  }

  public HideChildModal(): void {
    this.deleteVehicleMasterHashId = "";
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    let deletedVehicleList: any[];
    if (this.isMultipleDelete)
      deletedVehicleList = this.templateList.filter(x => x.isChecked).map(x => x.templateHashID);
    else
      deletedVehicleList.push(this.deleteVehicleMasterHashId);

    this.DeleteTemplate(deletedVehicleList);
    this.childModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public DeleteTemplate(deletedTemplateList: string[]) {
    this.isLoading = true;
    this.templateService.DeleteTemplates(deletedTemplateList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetTemplateList();
        this.popupMsg = this.translateService.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/template/components/template-list.component.ts